// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Testimonials_wrapper__gPI62","header":"Testimonials_header__FJ75d","simple":"Testimonials_simple__1BSp3"};